module.exports = __webpack_public_path__ + "img/face-meh.cecd2c13.svg";